import { skipToken } from '@tanstack/react-query';
import { useMemo } from 'react';
import { maxBy } from '../../../shared/utils/arrayUtils.ts';
import { Protocol } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


export function useLoadProtocol(
    protocolInput: Protocol | undefined,
    product: string | undefined,
) {

    const protocolFetch = trpc.protocols.get.useQuery(
        product ? { product, status: 'approved', isDisabled: false } : skipToken,
        {
            select: (protocols) => maxBy(protocols, p => +(p.createTime ?? 0)),
            refetchOnWindowFocus: false,
        },
    );

    const protocol = protocolInput ?? protocolFetch.data;

    const pdfFetch = trpc.protocolFiles.getPdf.useQuery(
        protocol?._id ? { protocolId: protocol._id } : skipToken,
        { refetchOnWindowFocus: false },
    );


    const visualPositions = useMemo(() => {
        if (!protocol) return [];
        return protocol.positions.filter(
            it => it.type === 'visualInspection' &&
                it.imageFileName !== undefined
        );
    }, [protocol]);

    const inspectionQueries = trpc.useQueries((t) =>
        visualPositions.map((it, index) =>
            t.protocolFiles.getVisualInspectionImage(
                {
                    imageFileName: it.imageFileName ?? '',
                    index
                },
                {
                    enabled: it.imageFileName !== undefined,
                    refetchOnWindowFocus: false,
                }
            )
        ) ?? []
    );

    const positionImages = useMemo(() => {
        const images = new Map<string, Uint8Array>();
        visualPositions?.forEach((it, index) => {
            if (inspectionQueries[index].data) {
                images.set(it.positionNumber, inspectionQueries[index].data);
            }
        });
        return images;
    }, [visualPositions, inspectionQueries]);


    return {
        protocol,
        pdfFetch,
        positionImages,
    }
}
